import React, { useEffect, useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { FaEdit, FaDownload, AiOutlineLink } from 'react-icons/all'
import moment from 'moment'
import Palette from '../../Palette'
import { useHistory } from 'react-router-dom'
import Member from '../../models/Member'

export default function MitraAccountProfilePage({ profileData }) {
    const history = useHistory()

    useEffect(() => {
        const userStorage = localStorage.getItem('user');
        if (!userStorage) {
            history.replace('/');
            return;
        }

        try {
            const user = JSON.parse(userStorage);
            if (user.role !== 'MITRA_SWASTA') {
                history.replace('/');
                return;
            }
        } catch (e) {
            console.error('Error parsing user data:', e);
            history.replace('/');
            return;
        }
    }, [history])

    console.log('arr', profileData)
    // value of profileDataPayload = {
    //     "id": 4677,
    //     "hpi_id": "MITRA-LALAION-010",
    //     "full_name": "Komune",
    //     "email": "rhrharyanto55+4201@gmail.com",
    //     "address_street": "Tangerang",
    //     "address_locality": "Tangerang",
    //     "address_region": "Banten",
    //     "address_postal": "15810",
    //     "phone_number": "8212918212912",
    //     "approval_date": "2025-10-07T17:00:00.000Z",
    //     "approved_by": 8,
    //     "commencement_date": "2025-10-07T17:00:00.000Z",
    //     "renewal_date": "2025-10-07T17:00:00.000Z",
    //     "approved_by_name": "master",
    //     "entry_date": "2025-10-09T07:55:50.000Z",
    //     "membership_confirmation": 0,
    //     "is_public": 0,
    //     "status": 1,
    //     "created_at": "2025-10-08T08:07:33.000Z",
    //     "modified_at": "2025-10-08T08:11:43.000Z",
    //     "active": 1,
    //     "role": "MITRA_SWASTA",
    //     "class_invited": 0,
    //     "from_migration": 0,
    //     "has_debt": 0,
    //     "sk_url": "https://wellsource.sgp1.digitaloceanspaces.com/sihapei_media/uploads/unknown/1759911101669-LICENSE",
    //     "membership_creation_status": "WAITING_APPROVE",
    //     "mitra_entity": "FOUNDATION",
    //     "mitra_policy_number": "1201201929",
    //     "mitra_website": "https://www.google.com/",
    //     "mitra_year_founded": 2026,
    // "mitra_attachment_portofolio" : [
    //     {
    //         "url": "https://wellsource.sgp1.digitaloceanspaces.com/sihapei_media/uploads/unknown/1760615847025-HPI - Prosedur Pendaftaran Mitra Swasta Terdaftar.docx",
    //         "name": "HPI - Prosedur Pendaftaran Mitra Swasta Terdaftar.docx"
    //     },
    //     {
    //         "url": "https://wellsource.sgp1.digitaloceanspaces.com/sihapei_media/uploads/unknown/1760615862215-dummy_1.jpg",
    //         "name": "dummy_1.jpg"
    //     }
    // ]
    //     "mitra_services": {
    //         "lainnya": false,
    //         "pelatihan": false,
    //         "penyusunan": false,
    //         "interpreting": true,
    //         "penerjemahan": true
    //     },
    //     "mitra_vision": "Mantappu",
    //     "mitra_mission": "Mantappu",
    //     "mitra_resource_translator": 12,
    //     "mitra_resource_intrepater": 30,
    //     "mitra_resource_has_referance": 1,
    //     "mitra_resource_reference": [
    //         {
    //             "hpi_id": "8219201023",
    //             "full_name": "Dora"
    //         },
    //         {
    //             "hpi_id": "81929129912",
    //             "full_name": "Dore"
    //         }
    //     ],
    //     "mitra_attachment_document": {
    //         "profile": [],
    //         "profession": [],
    //         "salinan_akta": [
    //             {
    //                 "url": "https://wellsource.sgp1.digitaloceanspaces.com/sihapei_media/uploads/unknown/1759809162401-PENYERAHAN DONASI (1).png",
    //                 "name": "PENYERAHAN DONASI (1).png"
    //             }
    //         ],
    //         "payment_proof": [],
    //         "salinan_nib_siup_tpd": [
    //             {
    //                 "url": "https://wellsource.sgp1.digitaloceanspaces.com/sihapei_media/uploads/unknown/1759809165265-PENYERAHAN DONASI.png",
    //                 "name": "PENYERAHAN DONASI.png"
    //             }
    //         ]
    //     },
    //     "mitra_pic_name": "Dorian",
    //     "mitra_pic_position": "Developer",
    //     "mitra_signature_date": "2025-10-07T17:00:00.000Z",
    //     "mitra_signature_image": "https://wellsource.sgp1.digitaloceanspaces.com/sihapei_media/uploads/unknown/1759809341131-PENYERAHAN DONASI.png"
    // }
    return (
        <>
            <Row style={{ marginTop: 20 }}>
                <Col>
                    {/* Profil Usaha Section */}
                    {/* <div
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '700',
                            fontSize: '1.2em',
                            color: Palette.PRIMARY,
                            marginBottom: 15,
                        }}
                        className="mt-4"
                    >
                        Profil Usaha
                    </div> */}
                    <div
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '600',
                            fontSize: '0.75em',
                            color: '#8e8e8e',
                            marginBottom: 7,
                        }}
                        className="mt-3 text-uppercase"
                    >
                        Tentang Mitra Swasta Terdaftar
                    </div>
                    <div style={{ maxHeight: 200, overflowY: 'scroll' }}>
                        {profileData?.about_me || '-'}
                    </div>
                    <div
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '600',
                            fontSize: '0.75em',
                            color: '#8e8e8e',
                            marginBottom: 7,
                        }}
                        className="mt-3 text-uppercase"
                    >
                        Tahun Berdiri
                    </div>
                    <div>
                        {profileData?.mitra_year_founded || '-'}
                    </div>
                    <hr></hr>

                    <div
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '600',
                            fontSize: '0.75em',
                            color: '#8e8e8e',
                            marginBottom: 7,
                        }}
                        className="mt-3 text-uppercase"
                    >
                        Bidang Layanan Bahasa Utama
                    </div>
                    <div>
                        {profileData?.mitra_services ? (
                            <ul style={{ paddingLeft: 20, marginBottom: 0 }}>
                                {Object.entries(profileData.mitra_services)
                                    .filter(([_, value]) => value === true)
                                    .map(([key, _]) => (
                                        <li key={key}>{Member.getServiceLabel(key)}</li>
                                    ))}
                            </ul>
                        ) : '-'}
                    </div>
                    <hr></hr>

                    <div
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '600',
                            fontSize: '0.75em',
                            color: '#8e8e8e',
                            marginBottom: 7,
                        }}
                        className="mt-3 text-uppercase"
                    >
                        Visi
                    </div>
                    <div style={{ whiteSpace: 'pre-line' }}>
                        {profileData?.mitra_vision || '-'}
                    </div>
                    <hr></hr>
                    <div
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '600',
                            fontSize: '0.75em',
                            color: '#8e8e8e',
                            marginBottom: 7,
                        }}
                        className="mt-3 text-uppercase"
                    >
                        Misi
                    </div>
                    <div style={{ whiteSpace: 'pre-line' }}>
                        {profileData?.mitra_mission || '-'}
                    </div>
                    <hr></hr>

                    <div
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '600',
                            fontSize: '0.75em',
                            color: '#8e8e8e',
                            marginBottom: 7,
                        }}
                        className="mt-3 text-uppercase"
                    >
                        Portofolio Layanan Utama/Klien
                    </div>
                    <div>
                        {profileData?.mitra_attachment_portofolio && profileData.mitra_attachment_portofolio.length > 0 ? (
                            <div className="mb-3">
                                {profileData.mitra_attachment_portofolio.map((doc, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            backgroundColor: Palette.PRIMARY,
                                            borderRadius: 5,
                                            display: 'inline-block',
                                            minWidth: 100,
                                            color: 'white',
                                            textAlign: 'center',
                                            paddingTop: 3,
                                            paddingBottom: 3,
                                            paddingRight: 5,
                                            paddingLeft: 5,
                                            marginRight: 10,
                                            marginBottom: 10,
                                        }}
                                    >
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                            <div style={{ flex: 1 }}>{doc.name}</div>
                                            <div style={{ alignItems: 'center', justifyContent: 'center' }}>
                                                <a href={doc.url} target="_blank" rel="noopener noreferrer">
                                                    <FaDownload style={{ color: 'white', marginRight: 5, marginLeft: 10 }} />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : '-'}
                    </div>

                    <hr></hr>

                    {/* Sumber Daya Manusia Section */}
                    <div
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '700',
                            fontSize: '1.2em',
                            color: Palette.PRIMARY,
                            marginBottom: 15,
                        }}
                        className="mt-4"
                    >
                        Sumber Daya Manusia
                    </div>

                    <div
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '600',
                            fontSize: '0.75em',
                            color: '#8e8e8e',
                            marginBottom: 7,
                        }}
                        className="mt-3 text-uppercase"
                    >
                        Jumlah Tenaga Penerjemah
                    </div>
                    <div>{profileData?.mitra_resource_translator ? `${profileData.mitra_resource_translator} Orang` : '-'}</div>
                    <hr></hr>
                    <div
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '600',
                            fontSize: '0.75em',
                            color: '#8e8e8e',
                            marginBottom: 7,
                        }}
                        className="mt-3 text-uppercase"
                    >

                        Jumlah Tenaga Juru Bahasa
                    </div>
                    <div>{profileData?.mitra_resource_intrepater ? `${profileData.mitra_resource_intrepater} Orang` : '-'}</div>
                    <hr></hr>
                    <div
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '600',
                            fontSize: '0.75em',
                            color: '#8e8e8e',
                            marginBottom: 7,
                        }}
                        className="mt-3 text-uppercase"
                    >
                        Anggota HPI di Dalam Tim
                    </div>
                    <div>
                        {profileData?.mitra_resource_has_referance ? 'Ya' : 'Tidak'}
                        {profileData?.mitra_resource_has_referance === 1 && profileData?.mitra_resource_reference && profileData.mitra_resource_reference.length > 0 && (
                            <div style={{ marginTop: 10 }}>
                                {profileData.mitra_resource_reference.map((ref, index) => (
                                    <div key={index} style={{ marginBottom: 5 }}>
                                        • {ref.full_name} ({ref.hpi_id})
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <hr></hr>

                    {/* Dokumen yang Dilampirkan Section */}
                    <div
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '700',
                            fontSize: '1.2em',
                            color: Palette.PRIMARY,
                            marginBottom: 15,
                        }}
                        className="mt-4"
                    >
                        Dokumen yang Dilampirkan
                    </div>

                    {profileData?.mitra_attachment_document?.salinan_akta && profileData.mitra_attachment_document.salinan_akta.length > 0 && (
                        <>
                            <div
                                style={{
                                    fontFamily: 'Signika',
                                    fontWeight: '600',
                                    fontSize: '0.75em',
                                    color: '#8e8e8e',
                                    marginBottom: 7,
                                }}
                                className="mt-3 text-uppercase"
                            >
                                Salinan Akta Pendirian Perusahaan/Badan Usaha
                            </div>
                            <div className="mb-3">
                                {profileData.mitra_attachment_document.salinan_akta.map((doc, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            backgroundColor: Palette.PRIMARY,
                                            borderRadius: 5,
                                            display: 'inline-block',
                                            minWidth: 100,
                                            color: 'white',
                                            textAlign: 'center',
                                            paddingTop: 3,
                                            paddingBottom: 3,
                                            paddingRight: 5,
                                            paddingLeft: 5,
                                            marginRight: 10,
                                            marginBottom: 10,
                                        }}
                                    >
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                            <div style={{ flex: 1 }}>{doc.name}</div>
                                            <div style={{ alignItems: 'center', justifyContent: 'center' }}>
                                                <a href={doc.url} target="_blank" rel="noopener noreferrer">
                                                    <FaDownload style={{ color: 'white', marginRight: 5, marginLeft: 10 }} />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}

                    {profileData?.mitra_attachment_document?.salinan_nib_siup_tpd && profileData.mitra_attachment_document.salinan_nib_siup_tpd.length > 0 && (
                        <>
                            <div
                                style={{
                                    fontFamily: 'Signika',
                                    fontWeight: '600',
                                    fontSize: '0.75em',
                                    color: '#8e8e8e',
                                    marginBottom: 7,
                                }}
                                className="mt-3 text-uppercase"
                            >
                                Salinan NIB/SIUP/TDP
                            </div>
                            <div className="mb-3">
                                {profileData.mitra_attachment_document.salinan_nib_siup_tpd.map((doc, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            backgroundColor: Palette.PRIMARY,
                                            borderRadius: 5,
                                            display: 'inline-block',
                                            minWidth: 100,
                                            color: 'white',
                                            textAlign: 'center',
                                            paddingTop: 3,
                                            paddingBottom: 3,
                                            paddingRight: 5,
                                            paddingLeft: 5,
                                            marginRight: 10,
                                            marginBottom: 10,
                                        }}
                                    >
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                            <div style={{ flex: 1 }}>{doc.name}</div>
                                            <div style={{ alignItems: 'center', justifyContent: 'center' }}>
                                                <a href={doc.url} target="_blank" rel="noopener noreferrer">
                                                    <FaDownload style={{ color: 'white', marginRight: 5, marginLeft: 10 }} />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}

                    {profileData?.mitra_attachment_document?.profile && profileData.mitra_attachment_document.profile.length > 0 && (
                        <>
                            <div
                                style={{
                                    fontFamily: 'Signika',
                                    fontWeight: '600',
                                    fontSize: '0.75em',
                                    color: '#8e8e8e',
                                    marginBottom: 7,
                                }}
                                className="mt-3 text-uppercase"
                            >
                                Profil Perusahaan
                            </div>
                            <div className="mb-3">
                                {profileData.mitra_attachment_document.profile.map((doc, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            backgroundColor: Palette.PRIMARY,
                                            borderRadius: 5,
                                            display: 'inline-block',
                                            minWidth: 100,
                                            color: 'white',
                                            textAlign: 'center',
                                            paddingTop: 3,
                                            paddingBottom: 3,
                                            paddingRight: 5,
                                            paddingLeft: 5,
                                            marginRight: 10,
                                            marginBottom: 10,
                                        }}
                                    >
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                            <div style={{ flex: 1 }}>{doc.name}</div>
                                            <div style={{ alignItems: 'center', justifyContent: 'center' }}>
                                                <a href={doc.url} target="_blank" rel="noopener noreferrer">
                                                    <FaDownload style={{ color: 'white', marginRight: 5, marginLeft: 10 }} />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}

                    {profileData?.mitra_attachment_document?.profession && profileData.mitra_attachment_document.profession.length > 0 && (
                        <>
                            <div
                                style={{
                                    fontFamily: 'Signika',
                                    fontWeight: '600',
                                    fontSize: '0.75em',
                                    color: '#8e8e8e',
                                    marginBottom: 7,
                                }}
                                className="mt-3 text-uppercase"
                            >
                                Daftar Penerjemah/Juru Bahasa Mitra/Tetap
                            </div>
                            <div className="mb-3">
                                {profileData.mitra_attachment_document.profession.map((doc, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            backgroundColor: Palette.PRIMARY,
                                            borderRadius: 5,
                                            display: 'inline-block',
                                            minWidth: 100,
                                            color: 'white',
                                            textAlign: 'center',
                                            paddingTop: 3,
                                            paddingBottom: 3,
                                            paddingRight: 5,
                                            paddingLeft: 5,
                                            marginRight: 10,
                                            marginBottom: 10,
                                        }}
                                    >
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                            <div style={{ flex: 1 }}>{doc.name}</div>
                                            <div style={{ alignItems: 'center', justifyContent: 'center' }}>
                                                <a href={doc.url} target="_blank" rel="noopener noreferrer">
                                                    <FaDownload style={{ color: 'white', marginRight: 5, marginLeft: 10 }} />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}



                    <hr></hr>

                    {/* Pernyataan Section */}
                    <div
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '700',
                            fontSize: '1.2em',
                            color: Palette.PRIMARY,
                            marginBottom: 15,
                        }}
                        className="mt-4"
                    >
                        Pernyataan
                    </div>

                    <div
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '600',
                            fontSize: '0.75em',
                            color: '#8e8e8e',
                            marginBottom: 7,
                        }}
                        className="mt-3 text-uppercase"
                    >
                        Nama Penanggung Jawab
                    </div>
                    <div>{profileData?.mitra_pic_name || '-'}</div>
                    <hr></hr>
                    <div
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '600',
                            fontSize: '0.75em',
                            color: '#8e8e8e',
                            marginBottom: 7,
                        }}
                        className="mt-3 text-uppercase"
                    >
                        Jabatan
                    </div>
                    <div>{profileData?.mitra_pic_position || '-'}</div>
                    <hr></hr>
                    <div
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '600',
                            fontSize: '0.75em',
                            color: '#8e8e8e',
                            marginBottom: 7,
                        }}
                        className="mt-3 text-uppercase"
                    >
                        Tanggal
                    </div>
                    <div>
                        {profileData?.mitra_signature_date
                            ? moment(profileData.mitra_signature_date).format('DD/MM/YYYY')
                            : '-'}
                    </div>
                    <hr></hr>
                    <div
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '600',
                            fontSize: '0.75em',
                            color: '#8e8e8e',
                            marginBottom: 7,
                        }}
                        className="mt-3 text-uppercase"
                    >
                        Tanda Tangan & Stempel Perusahaan
                    </div>
                    <div>
                        {profileData?.mitra_signature_image ? (
                            <img
                                src={profileData.mitra_signature_image}
                                alt="Tanda Tangan & Stempel"
                                style={{ maxWidth: '300px', maxHeight: '200px', border: '1px solid #ddd', padding: 10, borderRadius: 5 }}
                            />
                        ) : '-'}
                    </div>
                </Col>
            </Row>
        </>
    )
}